import { Component, Inject, forwardRef } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { ActionDefinitionSparePartReference, WorkOrder } from "../../model";
import { HttpUtility } from "../../utility";
import { ErrorUtility } from "../../utility/error-utility";
import { ActionListWidgetV2Service } from "./action-list-widget-v2.service";


@Component({
    selector: 'work-order-spare-part-list-dialog',
    template: require('./work-order-spare-part-list-dialog.component.html'),
    styles: [`
        mat-dialog-content {
            max-height: 448px;
        }
    `]
})
export class WorkOrderSparePartListDialogComponent {

    spareParts: ActionDefinitionSparePartReference[];
    error: string;
    loaded: boolean;
    displayedColumns: string[] = ['quantity', 'code'];

    private actionListWidgetV2Service: ActionListWidgetV2Service;

    constructor(
        @Inject(forwardRef(() => MatDialogRef)) public dialogRef: MatDialogRef<WorkOrderSparePartListDialogComponent>,
        @Inject(MAT_DIALOG_DATA) data,
        @Inject(forwardRef(() => HttpUtility)) private httpUtility: HttpUtility
    ) {
        this.actionListWidgetV2Service = data.actionListWidgetV2Service;
        this.getSpareParts(data.workOrder);
    }

    getSpareParts(workOrder: WorkOrder): void {
        this.loaded = false;
        this.actionListWidgetV2Service.getSparePartsFromWorkOrder(workOrder).then(spareParts => {
            this.spareParts = spareParts.sort((a, b) => (a.code > b.code) ? 1 : -1);
            this.error = null;
            this.loaded = true;
        }).catch(err => this.error = ErrorUtility.getMessage(err));
    }

    downloadCsv(): void {
        let sparePartsCsv = 'code,quantity,format\n';
        this.spareParts.forEach(sp => {
            let rowValues = [sp.code, sp.quantity];
            if (sp.format) {
                rowValues.push(sp.format);
            }
            sparePartsCsv += rowValues.join(',') + '\n';
        });
        let blob = new Blob([sparePartsCsv]);
        this.httpUtility.wrapFileAndDownload({ file: blob, fileName: "spareParts.csv" });
    }

}